module.exports = __webpack_public_path__ + "static/img/4141_phase_function_Paper_PointsHejduk_Prediction.fc00995.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4141_phase_function_Paper_PointsHejduk_Prediction.png
// module id = OMw7
// module chunks = 0